import { Button, Card, Form, Input, Space } from "antd";
import { useEffect } from "react";
import { useParams } from "react-router-dom";
import { useAppSelector } from "../../../app/store";
import LockIcon from "../../../assets/icons/LockIcon";
import { useUpdateOwnPasswordMutation } from "../../../features/portal/user/userApi";
import useError from "../../../hooks/useError";
import SidebarLayout from "../../../layouts/SidebarLayout";
import { toast } from "../../../lib/toast";
import UserInfo from "./UserInfo";

export default function ChangePassword() {
  const [form] = Form.useForm();
  const { id } = useParams();

  const { user } = useAppSelector((state) => state.auth);
  const [updateOwnPassword, { isError, error, isLoading, isSuccess }] =
    useUpdateOwnPasswordMutation();
  useError(isError, error, "User password update fail");

  const leaveSettingsTabList = [
    {
      label: "User Info",
      link: `/admin/user-info`,
    },
    {
      label: "Change Password",
      link: `/admin/change-password`,
    },
  ];

  const onFinish = (values: any) => {
    const newData = {
      emailOrUsername: user?.data?.username,
      oldPassword: values?.oldPassword,
      newPassword: values?.newPassword,
    };
    updateOwnPassword(newData);
  };

  useEffect(() => {
    if (isSuccess) {
      form.resetFields();
      toast("success", "Successfully password updated");
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [isSuccess]);

  return (
    <>
      <SidebarLayout
        title="Settings"
        tabList={leaveSettingsTabList}
        backLink="/admin/dashboard"
      >
        <div className="grid grid-cols-1 lg:grid-cols-3 gap-4 pt-4 pb-4">
          {/* Left Section */}
          <div className="space-y-4">
            <UserInfo />
          </div>
          {/* Right Section */}
          <div className="lg:col-span-2 space-y-4">
            <Card className="w-[470px]">
              <h4 className=" font-semibold text-[18px] text-[#5E718D]">
                Change Password
              </h4>

              <Form
                className="custom-form"
                layout="vertical"
                requiredMark="optional"
                size="large"
                onFinish={onFinish}
                form={form}
              >
                <Form.Item
                  name="oldPassword"
                  label="Old Password"
                  className="mb-[18px] mt-6"
                  rules={[
                    {
                      required: true,
                      message: "Please enter your old password",
                    },
                  ]}
                >
                  <Input.Password
                    prefix={<LockIcon />}
                    placeholder="Password"
                  />
                </Form.Item>

                <Form.Item
                  name="newPassword"
                  label="New Password"
                  className="mb-[18px] mt-3"
                  dependencies={["oldPassword"]}
                  rules={[
                    {
                      required: true,
                      message: "Please enter your new password",
                    },
                    {
                      min: 8,
                      message: "Password must be at least 8 characters",
                    },
                    ({ getFieldValue }) => ({
                      validator(_, value) {
                        if (!value || getFieldValue("oldPassword") !== value) {
                          return Promise.resolve();
                        }
                        return Promise.reject(
                          new Error(
                            "New password cannot be the same as old password"
                          )
                        );
                      },
                    }),
                  ]}
                >
                  <Input.Password
                    prefix={<LockIcon />}
                    placeholder="Password"
                  />
                </Form.Item>

                <Form.Item
                  name="confirmPassword"
                  label="Confirm New Password"
                  className="mb-[18px] mt-3"
                  rules={[
                    {
                      required: true,
                      message: "Please enter confirm password",
                    },
                    ({ getFieldValue }) => ({
                      validator(_, value) {
                        if (!value || getFieldValue("newPassword") === value) {
                          return Promise.resolve();
                        }
                        return Promise.reject(
                          new Error(
                            "Password and Confirm password do not match!"
                          )
                        );
                      },
                    }),
                  ]}
                >
                  <Input.Password
                    prefix={<LockIcon />}
                    placeholder="Password"
                  />
                </Form.Item>

                {/* <div className="mt-4 text-[#5E718D] text-sm">
                  [*Minimum 6 characters at least 1 Alphabet, 1 Number and 1
                  Special Character]
                </div> */}

                <Space className="flex gap-2 mt-6">
                  <Button
                    className="normal-dark-button modal-button"
                    size="middle"
                    onClick={() => {
                      form.setFieldsValue({});
                      form.resetFields();
                    }}
                  >
                    Cancel
                  </Button>
                  <Button
                    className="modal-button"
                    type="primary"
                    htmlType="submit"
                    size="middle"
                    loading={isLoading}
                  >
                    Save
                  </Button>
                </Space>
              </Form>
            </Card>
          </div>
        </div>
      </SidebarLayout>
    </>
  );
}
